import React, { useState, useEffect, useContext } from 'react';
import { ManagerContext } from '../../contexts/ManagerContext';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { Stack } from '@mui/material';
import { TramRounded } from '@mui/icons-material';
import { set } from 'zod';


const TitleBar = styled(DialogTitle)(({ theme }) => ({
  background: 'linear-gradient(45deg, #FE6B8B, #FF8E53)',
  color: '#fff',
  fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
}));

const ContentBody = styled(Typography)(({ theme }) => ({
  fontFamily: 'monospace',
  letterSpacing: '0.5px',
  lineHeight: 1.6,
  textAlign: 'justify',
}));

export default function ContactMessage( { _open, _setOpen, openBackDrop, closeBackDrop } ) {
  
  const { sendTask, currentUser } = useContext(ManagerContext);
  // const { openBackDrop, closeBackDrop } = React.useContext(UiContext);
  const [open, setOpen] = useState(false);
  const [name, setName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [topic, setTopic] = useState('');
  const [message, setMessage] = useState('');

  const handleClickOpen = () => {
    setOpen(true);
  };

  useEffect(() => {
    setOpen(_open)
  }, [_open])

  useEffect(() => {
    _setOpen(open)
  }, [open])

  const handleOutsideClick = (event) => {
    // Sprawdzamy, czy kliknięcie miało miejsce w obszarze formularza
    if (event.target.closest('.form-container')) {
      return;
    }
    handleClose()
  };

  const handleClose = () => {
    console.log('close')
    setName('');
    setLastName('');
    setEmail('');
    setPhone('');
    setTopic('');
    setMessage('');
    setOpen(false);
  };

  const handleSubmit = async () => {
    openBackDrop();
    const data = {
      name: name,
      last_name: lastName,
      email: email,
      phone: phone,
      topic: topic,
      message: message
    }

    const response = await sendTask('add_message_form', data)
    if(response?.result === 1) {
      setOpen(false)
      setName('');
      setLastName('');
      setEmail('');
      setPhone('');
      setTopic('');
      setMessage('');
      closeBackDrop();
      gtag('event', 'submit_form_message',{
        'event_category': 'chat',
        'event_label': 'User sent message',
        'value': 1
    });
    } else {
      closeBackDrop();
    }
  };

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  return (
    <Dialog
      open={open}
      scroll="body"
      fullWidth
      maxWidth="md"
      sx={(theme) => ({ zIndex: 1301, backdropFilter: 'blur(4px)' })}
      onClick={handleOutsideClick} // Zmiana na tę funkcję
    >
      <Container
        className="form-container"
        sx={{ zIndex: 1301, position: 'relative', height: 'fit-content', width: { xs: '100%', sm: '90%'} }}>

        <TitleBar>
        Write us a message
        </TitleBar>
        <form onSubmit={(e) => { e.preventDefault(); handleSubmit() }}>
          <DialogContent dividers sx={{ justifySelf: 'center', width: '100%' }}>
            <Stack direction={ 'row' } spacing={2} sx={{ mb: 2 }}>
              <TextField 
                required id="outlined-basic" 
                label="Name" 
                variant="outlined" 
                inputProps={{ maxLength: 50 }}
                sx={{ width: '100%' }}
                value={name}
                onChange={(e) => setName(e.target.value)} />
              <TextField 
                id="outlined-basic" 
                label="Last Name" 
                inputProps={{ maxLength: 50 }}
                variant="outlined" 
                sx={{ width: '100%' }}
                value={lastName}
                onChange={(e) => setLastName(e.target.value)} />
            </Stack>
            <TextField 
              required 
              type='email'
              inputProps={{ maxLength: 50 }}
              id="outlined-basic" 
              label="Email" 
              variant="outlined" 
              sx={{ width: '100%', mb: 2 }} 
              value={email}
              onChange={(e) => setEmail(e.target.value)} />
            <TextField 
              type='phone' 
              inputProps={{ maxLength: 20 }}
              id="outlined-basic" 
              label="Phone Number" 
              variant="outlined" 
              sx={{ width: '100%', mb: 2 }} 
              value={phone}
              onChange={(e) => setPhone(e.target.value)} />
            <TextField 
              id="outlined-basic" 
              label="Topic" 
              inputProps={{ maxLength: 50 }}
              variant="outlined" 
              sx={{ width: '100%', mb: 2 }} 
              value={topic}
              onChange={(e) => setTopic(e.target.value)} />
            
              {/* <FormControl sx={{ mb: 2, width: '100%' }}>
                <InputLabel id="demo-simple-select-autowidth-label">Age</InputLabel>
                <Select
                  required
                  labelId="demo-simple-select-autowidth-label"
                  id="demo-simple-select-autowidth"
                  // value={age}
                  onChange={handleChange}
                  autoWidth
                  label="Age"
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  <MenuItem value={20}>Twenty</MenuItem>
                  <MenuItem value={21}>Twenty one</MenuItem>
                  <MenuItem value={22}>Twenty one and a half</MenuItem>
                </Select>
              </FormControl> */}
            <TextField
              required
              id="auth_textarea"
              label="Message"
              multiline
              inputProps={{ maxLength: 1000 }}
              // autoFocus={activeRun.state === 'ready'}
              rows={12}
              sx={{ width: '100%', mb: 2 }}
              // disabled= {activeRun.state !== 'ready'}
              // variant="filled"
              // value={query}
              // style={{color: 'black'}}
              // style={{ maxLength: 5000, color:'black' }}
              // onChange={handleChange}
              // sx={{m: 1, width: {xs:'90%', sm:'60%'}, borderRadius: '10px', backgroundColor: 'rgba(30, 30, 30, 0.8)' }}
            />
            <Stack direction={ 'row' } spacing={2} sx={{ mb: 2 }}>
              <Button 
                variant='contained'
                color='error'
                type='button'
                sx={{ width: '100%' }}
                onClick={handleClose}>
                Cancel
              </Button>
              <Button 
                variant='contained'
                type='submit'
                color='primary'
                sx={{ width: '100%' }}
                // onClick={handleSubmit}
                >
                Send
              </Button>
              
            </Stack>
            <ContentBody variant="body1">

            </ContentBody>
          </DialogContent>
        </form>
      </Container>
      
    </Dialog>
  );
}